function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 .494h6.074v16.302c0 2.58 1.18 4.116 2.113 4.775-.987.878-4.006 1.647-6.257-.22C.603 20.251 0 18.442 0 16.741V.494zm37.961 13.542v-1.714h1.853v-6.01h-2.035C37 2.704 33.786 0 29.944 0c-4.426 0-8.014 3.588-8.014 8.014v14.035c1.261.177 2.763-.022 4.042-1.082 1.326-1.1 1.93-2.909 1.93-4.61v-.517h3.033V9.83h-3.033V8.013h.007c0-1.124.91-2.035 2.035-2.035 1.124 0 2.039.91 2.039 2.035v6.022c0 4.425 3.591 8.013 8.017 8.013v-5.978c-1.124 0-2.039-.912-2.039-2.035zM14.956 6.312v8.82c0 .501-.415.907-.928.907-.513 0-.928-.406-.928-.906v-8.82H7.09v10.373c0 1.866.632 4.226 3.513 4.995 2.883.77 4.555-.823 4.555-.823-.152 1.049-1.14 1.817-2.732 1.982-1.204.124-2.744-.275-3.513-.604v5.496c1.958.577 4.029.764 6.055.37 3.677-.713 5.998-3.786 5.998-7.876V6.312h-6.01z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 40,
    height: 29,
    viewBox: "0 0 40 29"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/lyft-logo.364740a5.svg";
export { SvgComponent as ReactComponent };